export class BreadcrumbItem {
  constructor(public label?: string, public active?: boolean, public url?: string) {}
}
